module.exports = __webpack_public_path__ + "media/images/dev/narrow-teaser-960x200-c5dd70d3818cfd549eee1a49cd07ca35.jpg";